/**
 * 로딩 씬 순수 로직 — Phaser 무의존. BootScene이 진행률→호 각도 매핑과 로딩 단계 전이를
 * 위임한다(렌더/씬 라이프사이클과 분리해 단위테스트 가능 — bug-reproduce-test-first §3 testable화).
 */

/**
 * 로딩 단계.
 * - assetsLoading: 에셋 로드 중(진행 호 갱신)
 * - assetsLoaded: 로드 완료 → GameScene launch + EVENT_READY 대기
 * - done: GameScene 준비 완료 → 오버레이 fade out + 씬 종료
 */
export type LoadingPhase = "assetsLoading" | "assetsLoaded" | "done";

/**
 * 단계 전이 이벤트.
 * - assets-complete: 에셋 로더 COMPLETE 콜백 수신 시(BootScene.onAssetsLoaded에서 발화)
 * - game-ready: GameScene EVENT_READY 수신 시(BootScene.attachGameReady에서 발화)
 */
export type LoadingEvent = "assets-complete" | "game-ready";

/**
 * 로딩 단계 순수 리듀서 — 정의된 전이만 진행하고, 그 외(잘못된 순서·중복 발화)는 현재 단계를
 * 유지한다(idempotent). 이중 발화 방어로 BootScene이 launch/fade를 두 번 트리거하지 않게 한다.
 *
 * assetsLoading --assets-complete--> assetsLoaded --game-ready--> done.
 */
export function advanceLoadingPhase(phase: LoadingPhase, event: LoadingEvent): LoadingPhase {
  if (phase === "assetsLoading" && event === "assets-complete") return "assetsLoaded";
  if (phase === "assetsLoaded" && event === "game-ready") return "done";
  return phase;
}

/**
 * 로딩 진행률(0~1)을 채움 호의 sweep 각도(라디안, 0~2π)로 매핑한다. 범위 밖 입력은 clamp,
 * NaN은 0으로 간주(로더 progress가 미정의 상태로 들어오는 부팅 초기 방어).
 */
export function loadingProgressToAngle(progress: number): number {
  if (Number.isNaN(progress)) return 0;
  const clamped = Math.max(0, Math.min(1, progress));
  return clamped * Math.PI * 2;
}
